export default __webpack_public_path__ + "static/media/RobotoSlab-Regular.33daf006.ttf";